/**
 * @author Adam Vlasek <adam.vlasek@styrax.cz>
 */

import React, { CSSProperties, useEffect, useRef } from 'react';

import SendableInterface from '../../types/SendableInterface';

type SendingContainerProps = SendableInterface & {
    children?: JSX.Element | any
}

const RELATIVE: CSSProperties = { position: 'relative' };
const BLOCK: CSSProperties = { display: 'block' };
const GLASS: CSSProperties = {
    background: 'rgba(255, 255, 255, .4)',
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: 1000
};
const RELATIVE_BLOCK: CSSProperties = { ...RELATIVE, ...BLOCK };
const GLASS_BLOCK: CSSProperties = { ...GLASS, ...BLOCK };
const MARGIN_BOTTOM: CSSProperties = { marginBottom: 5 };

/**
 * Odesilaci obalka, v dobe odesilani zobrazuje pres obsah loader.
 * @param children Funkce () => JSX.Element nebo JSX.Element s obsahem.
 * @param sending Boolean priznak, jestli probiha odesilani.
 * @param error Chybova hlaska.
 * @example <SendingContainer sending={} error={}>children</SendingContainer>
 * @returns React komponenta
 */
const SendingContainer = ({ children = null, sending, error }: SendingContainerProps): JSX.Element | null => {
    const errorRef = useRef<any>(null);

    //pokud se vyskytne error, tak se k němu automaticky odscrolluje
    useEffect(
        () => {
            if (!error || !errorRef?.current) return;

            errorRef.current.scrollIntoView();
        },
        [error, errorRef]
    );

    return (
        <React.Fragment>
            {
                error &&
                <div
                    ref={errorRef}
                    style={{
                        ...MARGIN_BOTTOM,
                        color: 'red'
                    }}>
                    <span dangerouslySetInnerHTML={{ __html: error.message }} />
                </div>
            }
            <span style={RELATIVE_BLOCK}>
                {
                    typeof children === 'function' ?
                        children() :
                        children
                }
                <span style={(sending && GLASS_BLOCK) || undefined} />
            </span>
        </React.Fragment >
    );
};

export default SendingContainer;
